import { takeEvery, call, put, cancelled } from 'redux-saga/effects';
import {
  REQUEST_ENUM_START,
} from '../actions';

angular.module('tct.sagas.enums', [])
  .factory('enumSagaFactory', enumSagaFactory);

enumSagaFactory.$inject = ['actionsFactory', 'enumService'];

function enumSagaFactory(actionsFactory, enumService) {
  const factory = {
    enumsFlow,
  };

  function* getEnums(action) {
    try {
      const enumRes = yield call(enumService.getEnums, action.path);
      const enums = enumRes.data && enumRes.data.data;
      yield put(actionsFactory.reqEnumSuccess(enums, action.path));
    } catch (err) {
      yield put(actionsFactory.reqEnumError(err));
    } finally {
      if (yield cancelled()) {
        console.log('cancelled');
      }
    }

    return 'done';
  }

  function* enumsFlow() {
    yield takeEvery(REQUEST_ENUM_START, getEnums);
  }

  return factory;
}
